import { useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { Loader2 } from "lucide-react";

import { GET_SESSION_FOR_PRINT } from "@/graphql/queries/sessions";
import { PrintTheorySheet } from "@/components/print-theory";

/**
 * The session's theory on paper. `?skill=` narrows it to the one topic a
 * grown-up opened from the question; without it the whole session prints, one
 * topic per page.
 */
export default function PrintTheoryPage() {
  const { id } = useParams<{ id: string }>();
  const [params] = useSearchParams();
  const skillKey = params.get("skill");

  const { data, loading } = useQuery(GET_SESSION_FOR_PRINT, {
    variables: { id },
    skip: !id,
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const session = data?.sessionForPrint;

  if (!session) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Sesija nerasta</p>
      </div>
    );
  }

  return <PrintTheorySheet session={session} skillKey={skillKey} />;
}
